import styled from '@emotion/styled';
import { css } from '@emotion/react';

export const StyledArrowDown = styled.div(({ trigger }: any) => {
  const defaultStyles = css`
    display: flex;
    align-items: center;
    justify-content: center;

    .item:hover &,
    a:hover & {
      .spline.one {
        transform: rotate(-135deg);
      }
      .spline.two {
        transform: rotate(135deg);
      }
    }

    .arrow-box {
      position: relative;
      width: 32px;
      height: 32px;
    }

    ${trigger &&
    css`
      .spline.one {
        transform: rotate(-135deg);
      }

      .spline.two {
        transform: rotate(135deg);
      }
    `}
  `;

  const styles = [defaultStyles];

  return styles;
});

export const ArrowSpline = styled.div`
  height: 1px;
  margin: 0;
  width: 14px;
  background: linear-gradient(
    270deg,
    rgba(255, 63, 0, 1) 0%,
    rgba(255, 63, 0, 1) 50%,
    rgba(251, 129, 28, 1) 100%
  );
  transition: 0.4s ease;

  &.one {
    display: block;
    position: absolute;
    transform: rotate(135deg);
    left: 45%;
    bottom: 62%;
  }

  &.two {
    display: block;
    position: absolute;
    transform: rotate(-135deg);
    left: 16%;
    bottom: 62%;
  }
`;
